<template>
  <li class="node-tree" :class="{ open: isOpen }" v-if="node.visible">
    <a v-if="showNodeControl" class="tree-control minus" @click="toggleNodeOpening(node)">
      <img src="/static/icons/icon-24.png" alt="Comprimi" class="tree-control">
    </a>
    <a v-if="showNodeControl" class="tree-control plus" @click="toggleNodeOpening(node)">
      <img src="/static/icons/icon-21.png" alt="Espandi" class="tree-control">
    </a>
    <label
      v-if="! isRoot"
      class="label"
      :class="{'group-block': isGroup}"
    >
      <img v-if="isSelectable && isSelected"
           src="/static/icons/icon-22.png"
           alt="checked"
           class="tree-control"
           @click="toggleNodeSelection(node)">
      <img v-if="isSelectable && !isSelected"
           src="/static/icons/icon-23.png"
           alt="unchecked"
           class="tree-control"
           @click="toggleNodeSelection(node)">

      <div
        v-if="isGroup"
        class="group d-flex justify-content-between align-items-center"
        @click="toggleNodeOpening(node)"
      >
        <div class="group-title-block d-flex justify-content-between align-items-center">
          <div class="group-icon">
            <font-awesome-icon :icon="groupIcon" />
          </div>
          <div class="group-title">
            {{ node.name }}
          </div>
        </div>

        <font-awesome-icon
          v-if="isOpen"
          class="arrow arrow-down"
          icon="chevron-down"/>
        <font-awesome-icon
          v-else
          class="arrow arrow-right"
          icon="chevron-right"/>

      </div>

      <span
        v-if="!isGroup"
        :class="{'col-10 side-icon': isGroup }"
        @click="node.type == 'site' ? toggleNodeOpening(node) : toggleNodeSelection(node)"
      >
        {{ node.name }}
        <font-awesome-icon
          v-if="node.is_virtual == 0 && ! node.formula && ! node.custom_formula"
          style="font-size: 10px; margin-bottom: 1px"
          icon="circle" />
      </span>
    </label>

    <ul v-if="hasVisibleChildren">
      <TreeNode v-for="child in visibleChildren"
                :key="child.code"
                :node="child"
                @toggle-node-opening="toggleNodeOpening"
                @toggle-node-selection="toggleNodeSelection"
                @toggle-parameter="toggleParameter"/>
    </ul>

    <ul v-if="node.parameters">
      <li v-for="(p, i) in nodeParameters" :key="i">
        <label class="label" @click="toggleParameter(p)">
          <img v-if="p.selected"
               src="/static/icons/icon-22.png" alt="check" class="tree-control">
          <img v-if="!p.selected"
               src="/static/icons/icon-23.png" alt="check" class="tree-control">
          <span>{{ p.name }}</span>
        </label>
      </li>
    </ul>
  </li>
</template>

<script>
import config from '@/config.json';

export default {
  name: 'TreeNode',

  props: {
    node: Object,
  },

  data() {
    return {
      selected: false,
    }
  },

  computed: {
    showNodeControl() {
      return !this.isRoot && this.hasVisibleChildren && !this.isGroup;
    },

    code() {
      return this.node.code;
    },

    nodeParameters() {
      return this.node.parameters ? this.node.parameters.filter(p => ! p.value) : null;
    },

    hasVisibleChildren() {
      return (this.node.children && this.node.children.filter(c => c.visible).length > 0) || this.node.parameters;
    },

    visibleChildren() {
      return this.node.children.filter(c => c.visible)
    },

    isOpen() {
      return this.isRoot ? true : this.node.open;
    },

    isRoot() {
      return this.code === '__sites__';
    },

    isGroup() {
      return this.node.type === 'group';
    },

    groupIcon() {
      if (!this.isGroup) {
        return '';
      }

      const iconSettings = config.sideMenu.icons;
      var codeData = this.code.split('-');
      var code = codeData[codeData.length - 1];
      return iconSettings[code] || iconSettings.default;
    },

    isSelectable() {
      return this.node.selectable;
    },

    isSelected() {
      return this.node.selected;
    },
  },

  methods: {
    toggleNodeOpening(node) {
      this.$emit('toggle-node-opening', node);
    },

    toggleNodeSelection(node) {
      this.$emit('toggle-node-selection', node);
    },

    toggleParameter(parameter) {
      this.$emit('toggle-parameter', parameter);
    },
  }
}
</script>

<style>
.parameters li,
.sidebar .sidebar-menu li.node-tree {
  list-style-type: none;
  font-size: 14px;
  padding: 3px 0px;
}

.sidebar .sidebar-menu li.node-tree .label {
  white-space: nowrap;
  font-weight: 300;
  background: transparent;
  color: #fff;
  font-size: 14px;
  padding: 0;
  cursor: pointer;
}

.sidebar .sidebar-menu li.node-tree > ul {
  display: none;
}

.sidebar .sidebar-menu li.node-tree.open > ul {
  display: block;
}

.sidebar .sidebar-menu li.node-tree > .minus,
.sidebar .sidebar-menu li.node-tree > .plus,
.sidebar .sidebar-menu li.node-tree > .minus:hover,
.sidebar .sidebar-menu li.node-tree > .plus:hover {
  background: transparent;
  color: #7C3437;
}

.sidebar .sidebar-menu li.node-tree > .minus {
  display: none;
}

.sidebar .sidebar-menu li.node-tree.open > .minus {
  display: inline;
}

.sidebar .sidebar-menu li.node-tree > .plus {
  display: inline;
}

.sidebar .sidebar-menu li.node-tree.open > .plus {
  display: none;
}

.parameters ul {
  padding-left: 0;
}

.parameters {
  margin-top: 10px;
  margin-bottom: 30px;
}

.tree-control {
  cursor: pointer;
}

.tree-control {
  width: 14px;
  height: 14px;
}

.sidebar .sidebar-menu li.node-tree .group-block {
  width: 100%;
  padding-right: 15px;
}

.group {
  display: flex;
}

.group-icon {
  margin-right: 10px;
}

.group-title {
  font-size: 16px;
}


.sidebar_report .sidebar-menu li.node-tree {
  list-style-type: none;
  font-size: 14px;
  padding: 3px 0px;
}

.sidebar_report .sidebar-menu li.node-tree .label {
  white-space: nowrap;
  font-weight: 300;
  background: transparent;
  color: #fff;
  font-size: 14px;
  padding: 0;
  cursor: pointer;
}

.sidebar_report .sidebar-menu li.node-tree > ul {
  display: none;
}

.sidebar_report .sidebar-menu li.node-tree.open > ul {
  display: block;
}

.sidebar_report .sidebar-menu li.node-tree > .minus,
.sidebar_report .sidebar-menu li.node-tree > .plus,
.sidebar_report .sidebar-menu li.node-tree > .minus:hover,
.sidebar_report .sidebar-menu li.node-tree > .plus:hover {
  background: transparent;
  color: #7C3437;
}

.sidebar_report .sidebar-menu li.node-tree > .minus {
  display: none;
}

.sidebar_report .sidebar-menu li.node-tree.open > .minus {
  display: inline;
}

.sidebar_report .sidebar-menu li.node-tree > .plus {
  display: inline;
}

.sidebar_report .sidebar-menu li.node-tree.open > .plus {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Tree/TreeNode.vue